<template>
  <div>
    <div v-if="gameState.step === 'waiting-for-move' && !gameOver">
      <div class="flex flex-row gap-2 justify-center mt-3">
        <button
          data-action="h"
          class="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl uppercase px-4 py-2 font-bold text-white bg-green rounded-sm shadow-sm"
        >
          Hit
        </button>
        <button
          data-action="s"
          class="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl uppercase px-4 py-2 font-bold text-white bg-green-light rounded-sm shadow-sm"
        >
          Stand
        </button>
        <button
          v-if="gameState.focusedHand.firstMove"
          data-action="d"
          class="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl uppercase px-4 py-2 font-bold text-white bg-orange-light rounded-sm shadow-sm"
        >
          Double
        </button>

        <button
          v-if="
            gameState.focusedHand &&
              gameState.focusedHand.hasPairs &&
              player.hands.length < 4
          "
          data-action="p"
          class="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl uppercase px-4 py-2 font-bold text-white bg-marine rounded-sm shadow-sm"
        >
          Split
        </button>
      </div>
    </div>
    <div v-else-if="gameOver" class="relative w-full text-center">
      Caricamento...
    </div>
    <div v-else-if="gameState.step === 'ask-insurance'" class="relative w-full">
      <div class="mx-auto">
        <div class="flex flex-col">
          <p class="mb-2 text-3xl">Assicurazione?</p>
          <div class="flex flex-row gap-1 justify-center">
            <button
              data-action="y"
              class="text-3xl uppercase px-4 py-2 font-bold text-white bg-marine rounded-sm shadow-sm"
            >
              Sì
            </button>
            <button
              data-action="n"
              class="text-3xl uppercase px-4 py-2 font-bold text-white bg-marine rounded-sm shadow-sm"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
    <transition name="slide-fade" mode="out-in" v-else-if="showResults">
      <div class="fixed z-10 inset-0 overflow-y-auto">
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div class="fixed inset-0">
            <div class="absolute inset-0 bg-green-500 opacity-75 slide-top"></div>
            <button
              class="p-6 font-bold text-black bg-white inline-block rounded-lg overflow-hidden shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full mt-56 animated fadeIn"
              data-action="d"
            >
              <div v-if="getWinner[0] === 'push'" data-action="d">
                PARITÀ! Clicca qui per ricominciare
              </div>
              <div v-else data-action="d" class="uppercase">
                {{ getWinner[0] }} vince! Clicca qui per ricominciare
              </div>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import store from "../store";

export default {
  name: "Choices",
  store,
  data: function() {
    return { gameOver: false, showResults: false };
  },

  created() {
    this.$eventHub.$on("game-over", () => {
      this.gameOver = true;
      setTimeout(() => {
        this.gameOver = false;
        this.showResults = true;
      }, 1500);
    });
  },

  computed: {
    gameState() {
      return this.$store.getters.gameState;
    },
    player() {
      return this.$store.getters.player;
    },

    getWinner() {
      return this.$store.getters.playerHands.map(e => {
        return this.$store.getters.gameState.handWinner[e.id];
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Choices.vue